import { useQuery } from '@tanstack/react-query';
import useHttpClient from './useHttpClient';
import { IProject } from './models/project';

interface IProjectSearchResponse {
  count: number;
  items: IProject[];
  hasMore: boolean;
  limit: number;
}

/**
 * TanStack Query version of useQueryProjects
 * Fetches projects using HTTP client with parameter-based reactivity
 */
const useQueryProjects = (searchTerm: string | null) => {
  const httpClient = useHttpClient();

  return useQuery<IProjectSearchResponse>({
    queryKey: ['projects', searchTerm],
    queryFn: async () => {
      if (!searchTerm) {
        throw new Error('Search term not provided');
      }

      // Build query parameters
      const params = new URLSearchParams({ searchTerm });
      const response = await httpClient.get(`/projects?${params.toString()}`);
      return response.data;
    },
    enabled: searchTerm !== null && searchTerm.length > 0, // Only fetch when search term is provided
  });
};

export default useQueryProjects;
